/* */ 
'use strict';
Object.defineProperty(exports, "__esModule", {value: true});
exports.default = isMultibyte;
var _assertString = require('./util/assertString');
var _assertString2 = _interopRequireDefault(_assertString);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
var multibyte = /[^\x00-\x7F]/;
function isMultibyte(str) {
  (0, _assertString2.default)(str);
  return multibyte.test(str);
}
module.exports = exports['default'];
